import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/search";

function searchUrl(queryString) {
  return `${apiEndpoint}?${queryString}`;
}

export function getSearchResults(queryString) {
  const url = searchUrl(queryString);
  console.log(url);
  return http.get(url);
}
